@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

<form [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">
  <div class="new-password-form">
    <bmcore-input formControlName="password" [title]="'Password'" [type]="'password'" [controlFormName]="'password'">
    </bmcore-input>
    <bmcore-input
      formControlName="confirmPassword"
      [title]="'Confirm password'"
      [type]="'password'"
      [controlFormName]="'confirmPassword'"
    >
    </bmcore-input>

    <p class="bm--auth-form__hint">Your new password be different from previous used password</p>
  </div>

  <div class="bm--auth-form-btn-container">
    <bmcore-button title="Create new password" styleName="center" [disabled]="isLoader"> </bmcore-button>
  </div>
</form>
